/* DiFluid OS — stage pages on the system-first layout.

   One script for Farm & green, Roast, Brew and Systems once each is
   moved over. It paints a section marked data-os-room="<slug>" from
   OS_CONTENT.STAGES[slug]:

     1. the persona headline and line under the stage photograph
     2. the system for that reader, from the section's catalog
     3. the flow: each device, the Tool it fills, the bean it saves to,
        drawn with connectors that are measured, not guessed
     4. one block per device, with the CoffeeOS screen it fills and the
        figures called out beside the screen
     5. sharing
     6. Learn cards and the doors to the other stages

   Role changes repaint the lines that depend on the role and leave
   the photographs where they are. Connectors are re-solved on load,
   resize, font load and role change. */
(function () {
  "use strict";
  function T(k, en) { var t = window.OS_T; return (t && typeof t[k] === "string" && t[k]) || en; }
  var D = document;
  var C = window.OS_CONTENT;
  var root = D.querySelector("[data-os-room]");
  if (!C || !root) return;
  var slug = root.getAttribute("data-os-room");
  var S = C.STAGES[slug];
  if (!S) return;

  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── small helpers ─────────────────────────────────────────── */
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function img(key) { return (window.OS_IMAGES || {})[key] || ""; }
  function gear(key) { return (window.OS_GEAR || {})[key] || ""; }
  function icon(key) { return (window.OS_ICONS || {})[key] || ""; }
  function toolUrl(key) { return (window.OS_TOOL_URLS || {})[key] || ""; }
  function roomUrl(key) { return (window.OS_LINKS || {})[key] || "#"; }
  function role() {
    try { return window.OS && window.OS.currentId ? window.OS.currentId() : "roaster"; }
    catch (e) { return "roaster"; }
  }
  function pick(map, id) {
    if (!map) return "";
    if (typeof map === "string") return map;
    return C.pick(map, id);
  }
  function catalog() {
    var raw = root.parentNode.querySelector("[data-os-catalog]") || D.querySelector("[data-os-catalog]");
    if (!raw) return {};
    try { return JSON.parse(raw.textContent).products || {}; } catch (e) { return {}; }
  }
  var products = catalog();

  /* The same headline treatment os.js uses: each word rises in,
     the outgoing line leaves as one block, the rule wipes. */
  function wordLayer(text, cls) {
    var p = D.createElement("p");
    p.className = cls + " os-layer";
    String(text).split(/\s+/).forEach(function (w, i, arr) {
      var s = D.createElement("span");
      s.className = "os-w"; s.style.setProperty("--i", i);
      var inner = D.createElement("i"); inner.textContent = w;
      s.appendChild(inner); p.appendChild(s);
      if (i < arr.length - 1) p.appendChild(D.createTextNode(" "));
    });
    return p;
  }
  function swapHeadline(wrap, text, cls) {
    if (!wrap) return;
    var live = wrap.querySelectorAll("." + cls + ":not(.is-out)");
    var old = live.length ? live[live.length - 1] : null;
    if (old && old.textContent.replace(/\s+/g, " ").trim() === String(text).trim()) return;
    /* Two layers can be live for a frame when a change arrives twice. */
    for (var k = 0; k < live.length - 1; k++) live[k].classList.add("is-out");
    var next = wordLayer(text, cls);
    wrap.appendChild(next);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      next.classList.add("is-in");
      if (old) { old.classList.add("is-out"); setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, 900); }
    }); });
    var rule = wrap.parentNode && wrap.parentNode.querySelector("[data-os-rule]");
    if (rule) { rule.classList.remove("is-wipe"); void rule.offsetWidth; rule.classList.add("is-wipe"); }
  }
  function swapText(el, text) {
    if (!el) return;
    if (el.textContent.trim() === String(text).trim()) { el.hidden = !text; return; }
    el.classList.add("is-out");
    setTimeout(function () { el.textContent = text; el.hidden = !text; el.classList.remove("is-out"); }, 300);
  }
  function fadeSwap(el, fn) {
    if (!el) return;
    el.classList.add("is-out");
    setTimeout(function () { fn(); el.classList.remove("is-out"); }, 300);
  }

  /* ── 1. headline ───────────────────────────────────────────── */
  function paintHead(id) {
    var h = S.head[id] || S.head[C.FAMILY[id]] || S.head.roaster || S.head[Object.keys(S.head)[0]] || { h: "", n: "" };
    swapHeadline(root.querySelector("[data-os-roomhead]"), h.h, "os-roomhead__layer");
    swapText(root.querySelector("[data-os-note]"), h.n);
    var t = root.querySelector("[data-os-stagetitle]");
    if (t && t.textContent.trim() !== S.title) t.textContent = S.title;
  }

  /* ── 2. the system ─────────────────────────────────────────── */
  function systemFor(id) {
    var m = S.system || {};
    return m[id] || m[C.FAMILY[id]] || m["default"] || null;
  }
  function systemHTML(id) {
    var k = systemFor(id);
    if (!k) return "";
    var p = products[k.h];
    if (!p) return "";
    var devs = (S.flow && S.flow.links || []).map(function (l) {
      var src = gear(l.gear);
      return src ? '<img src="' + esc(src) + '" alt="' + esc(l.name) + '" loading="lazy">' : "";
    }).join("");
    return (
      '<a class="os-rm__sysshot" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : "") +
      "</a>" +
      '<div class="os-rm__syssay">' +
        '<p class="os-eyebrow">' + esc((S.system && S.system.eyebrow) || T("room.system_for_you", "The system for you")) + "</p>" +
        '<h2><a href="' + esc(p.url) + '">' + esc(k.name || p.name) + "</a></h2>" +
        '<p class="os-rm__lead">' + esc(k.lead) + "</p>" +
        '<p class="os-rm__buy">' +
          "<b>" + esc(p.price) + "</b>" +
          (p.was ? "<s>" + esc(p.was) + "</s>" : "") +
          (p.avail !== false
            ? '<a class="os-btn os-btn--primary" href="' + esc(p.url) + '">' + esc((S.system && S.system.cta) || T("room.see_whats_in_it", "See what is in it")) + "</a>"
            : '<span class="os-rm__soon">' + esc(T("room.back_soon", "Back soon")) + "</span>") +
        "</p>" +
      "</div>"
    );
  }
  function paintSystem(id, first) {
    var el = root.querySelector("[data-os-system]");
    if (!el) return;
    var go = function () {
      var html = systemHTML(id);
      el.hidden = !html;
      el.innerHTML = html;
    };
    if (first) go(); else fadeSwap(el, go);
  }

  /* ── callouts ──────────────────────────────────────────────
     A phone screen with the figures worth seeing labelled beside
     it. Each label sits in a column next to the screen and a thin
     line runs to the point it describes. The label never sits on
     the screen. Positions are percentages of the image. */
  function shotHTML(key, alt, callouts, side) {
    var u = img(key);
    if (!u) return "";
    var labels = (callouts || []).map(function (c, i) {
      return '<li class="os-rm__call" data-x="' + (+c.x) + '" data-y="' + (+c.y) + '"' + (c.point ? ' data-point="1"' : "") + ' style="--i:' + i + '"><b>' + (i + 1) + "</b>" + esc(c.t) + "</li>";
    }).join("");
    var pins = (callouts || []).map(function (c, i) {
      return '<i class="os-rm__pin" style="left:' + (+c.x) + "%;top:" + (+c.y) + '%">' + (i + 1) + "</i>";
    }).join("");
    return (
      '<figure class="os-rm__shot os-rm__shot--' + (side || "right") + '" data-os-shot>' +
        '<div class="os-rm__phone"><img src="' + esc(u) + '" alt="' + esc(alt || "") + '" loading="lazy">' + pins + "</div>" +
        (labels ? '<ul class="os-rm__calls">' + labels + "</ul>" : "") +
        '<svg class="os-rm__wires" aria-hidden="true"></svg>' +
      "</figure>"
    );
  }

  /* ── 3. the flow ───────────────────────────────────────────── */
  /* Links that name the same Tool one after another share one Tool
     card, which spans their rows: four color meters all fill the
     Roast Color Analyzer, so the flow converges on it. A page where
     every link has its own Tool gets one card per row, as before. */
  function flowGroups(links) {
    var groups = [];
    (links || []).forEach(function (l, i) {
      var last = groups[groups.length - 1];
      if (last && last.tool === l.tool && l.tool) last.items.push(i);
      else groups.push({ tool: l.tool, toolName: l.toolName, toolLine: l.toolLine, items: [i] });
    });
    return groups;
  }
  function flowHTML(id) {
    var F = S.flow;
    if (!F) return "";
    var links = F.links || [];
    var rows = flowGroups(links).map(function (grp, gi) {
      var ic = icon(grp.tool), url = toolUrl(grp.tool);
      var toolName = url ? '<a href="' + esc(url) + '">' + esc(grp.toolName) + "</a>" : esc(grp.toolName);
      var hub = grp.items.length > 1;
      var devs = grp.items.map(function (i) {
        var l = links[i], g = gear(l.gear);
        return (
          '<div class="os-rm__dev" data-flow-dev="' + i + '" data-flow-group="' + gi + '" style="--r:' + i + '">' +
            '<span class="os-rm__devimg">' + (g ? '<img src="' + esc(g) + '" alt="" loading="lazy">' : "") + "</span>" +
            "<span><strong>" + esc(l.name) + "</strong><span>" + esc(l.measure) + "</span></span>" +
          "</div>"
        );
      }).join("");
      return (
        '<div class="os-rm__row' + (hub ? " os-rm__row--hub" : "") + '" data-flow-row="' + gi + '" style="--i:' + gi + '">' +
          devs +
          '<div class="os-rm__tool' + (hub ? " os-rm__tool--hub" : "") + '" data-flow-tool="' + gi + '" style="--r:' + grp.items[0] + ";--span:" + grp.items.length + '">' +
            '<span class="os-rm__tile">' + (ic ? '<img src="' + esc(ic) + '" alt="" loading="lazy">' : "") + "</span>" +
            "<span><strong>" + toolName + "</strong><span>" + esc(grp.toolLine || "") + "</span></span>" +
          "</div>" +
        "</div>"
      );
    }).join("");
    var cols = F.cols || [T("room.col_measure", "Measure"), T("room.col_in_coffeeos", "In CoffeeOS"), T("room.col_on_the_bean", "On the bean")];
    return (
      '<div class="os-rm__flowhead">' +
        '<h2 class="os-rm__h2">' + esc(F.h) + "</h2>" +
        '<p class="os-rm__p" data-os-flowline>' + esc(pick(F.n, id)) + "</p>" +
      "</div>" +
      '<div class="os-rm__graph" data-os-graph style="--n:' + (F.links || []).length + '">' +
        '<p class="os-eyebrow os-rm__colhead os-rm__colhead--dev">' + esc(cols[0]) + "</p>" +
        '<p class="os-eyebrow os-rm__colhead os-rm__colhead--tool">' + esc(cols[1]) + "</p>" +
        '<p class="os-eyebrow os-rm__colhead os-rm__colhead--bean">' + esc(cols[2]) + "</p>" +
        rows +
        '<div class="os-rm__bean">' + (F.record ? shotHTML(F.record.img, F.record.alt, F.record.callouts, "right") : "") + "</div>" +
        '<svg class="os-rm__links" aria-hidden="true"></svg>' +
      "</div>"
    );
  }
  function paintFlow(id, first) {
    var el = root.querySelector("[data-os-flow]");
    if (!el || !S.flow) return;
    if (first) {
      el.innerHTML = flowHTML(id);
      el.hidden = false;
      return;
    }
    swapText(el.querySelector("[data-os-flowline]"), pick(S.flow.n, id));
  }

  /* ── 3b. the chain ─────────────────────────────────────────
     Where each reading happens, in the order the coffee meets it:
     the cherry, the drying bed, the warehouse, the sample roast.
     Only a page whose deck carries `chain` paints it. */
  function chainHTML(id) {
    var Ch = S.chain;
    if (!Ch) return "";
    var steps = (Ch.steps || []).map(function (s, i) {
      var g = gear(s.gear);
      return (
        '<li class="os-rm__step" style="--i:' + i + '">' +
          '<span class="os-rm__stepart">' + (g ? '<img src="' + esc(g) + '" alt="" loading="lazy">' : "") + "</span>" +
          '<span class="os-eyebrow">' + esc(s.place) + "</span>" +
          "<strong>" + esc(s.reading) + "</strong>" +
          "<span>" + esc(s.name) + "</span>" +
        "</li>"
      );
    }).join("");
    return (
      '<div class="os-rm__flowhead">' +
        '<h2 class="os-rm__h2">' + esc(Ch.h) + "</h2>" +
        '<p class="os-rm__p" data-os-chainline>' + esc(pick(Ch.n, id)) + "</p>" +
      "</div>" +
      '<ol class="os-rm__steps" style="--n:' + (Ch.steps || []).length + '">' + steps + "</ol>"
    );
  }
  function paintChain(id, first) {
    var el = root.querySelector("[data-os-chain]");
    if (!el || !S.chain) return;
    if (first) { el.innerHTML = chainHTML(id); el.hidden = false; return; }
    swapText(el.querySelector("[data-os-chainline]"), pick(S.chain.n, id));
  }

  /* ── 4. the devices ────────────────────────────────────────── */
  function toolHTML(t, id, i) {
    var p = products[t.slug];
    var also = t.alsoSlug ? products[t.alsoSlug] : null;
    var u = img(t.img), ic = icon(t.tool), turl = toolUrl(t.tool);
    var why = C.pick(t.why, id);
    var name = p ? '<a href="' + esc(p.url) + '">' + esc(t.name) + "</a>" : esc(t.name);
    /* The Tool this device fills, or, for one that fills none (a
       smoke filter, a refractometer with its own screen), the line
       the deck gives in `mark`. */
    var toolMark = t.tool
      ? '<p class="os-rm__toolmark">' +
          (ic ? '<img src="' + esc(ic) + '" alt="" loading="lazy">' : "") +
          "<span>" + T("room.tool_in_coffeeos", "{tool} in CoffeeOS").split("{tool}").map(esc).join(turl ? '<a href="' + esc(turl) + '">' + esc(t.toolName) + "</a>" : esc(t.toolName)) + "</span></p>"
      : (t.mark ? '<p class="os-rm__toolmark"><span>' + esc(t.mark) + "</span></p>" : "");
    var shot = shotHTML(t.shot, t.shotAlt, t.callouts, "right");
    var buy = p
      ? '<p class="os-rm__buy"><b>' + esc(p.price) + "</b>" +
          (p.avail !== false ? '<a class="os-btn os-btn--secondary" href="' + esc(p.url) + '">' + esc(t.name) + "</a>" : '<span class="os-rm__soon">' + esc(T("room.back_soon", "Back soon")) + "</span>") +
          (also ? '<a class="os-rm__also" href="' + esc(also.url) + '">' + esc(T("room.also_or", "or {name}, {price}")).replace("{name}", function () { return esc(t.alsoName || also.name); }).replace("{price}", function () { return esc(also.price); }) + "</a>" : "") +
        "</p>"
      : "";
    return (
      '<article class="os-rm__device' + (i % 2 ? " os-rm__device--flip" : "") + (shot ? "" : " os-rm__device--noshot") + '" data-os-rmtool="' + esc(t.slug) + '">' +
        '<div class="os-rm__photo">' + (u ? '<img src="' + esc(u) + '" alt="' + esc(t.alt || "") + '" loading="lazy"' + (t.pos ? ' style="object-position:' + esc(t.pos) + '"' : "") + ">" : "") + "</div>" +
        '<div class="os-rm__copy">' +
          toolMark +
          '<h2 class="os-rm__h2">' + esc(t.h) + "</h2>" +
          '<p class="os-rm__p">' + esc(t.does) + "</p>" +
          '<p class="os-rm__why" data-os-why' + (why ? "" : " hidden") + ">" + esc(why) + "</p>" +
          '<p class="os-rm__name">' + name + (t.spec ? ' <span class="os-rm__spec">' + esc(t.spec) + "</span>" : "") + "</p>" +
          buy +
        "</div>" +
        shot +
      "</article>"
    );
  }
  function paintTools(id, first) {
    var el = root.querySelector("[data-os-rmtools]");
    if (!el) return;
    if (first) {
      el.innerHTML = (S.tools || []).map(function (t, i) { return toolHTML(t, id, i); }).join("");
      return;
    }
    var whys = el.querySelectorAll("[data-os-why]");
    for (var i = 0; i < whys.length; i++) {
      (function (w, t, n) {
        setTimeout(function () { swapText(w, C.pick(t.why, id)); }, n * 85);
      })(whys[i], S.tools[i], i);
    }
  }

  /* ── 5. sharing ────────────────────────────────────────────── */
  function paintShare(id, first) {
    var el = root.querySelector("[data-os-share]");
    var Sh = S.share;
    if (!el || !Sh) return;
    if (first) {
      el.innerHTML =
        '<div class="os-rm__copy">' +
          '<p class="os-eyebrow">' + esc(T("room.then_you_send_it", "Then you send it")) + "</p>" +
          '<h2 class="os-rm__h2">' + esc(Sh.h) + "</h2>" +
          '<p class="os-rm__p" data-os-shareline>' + esc(pick(Sh.b, id)) + "</p>" +
          (Sh.card && img(Sh.card)
            ? '<figure class="os-rm__sharecard"><img src="' + esc(img(Sh.card)) + '" alt="' + esc(Sh.cardAlt || "") + '" loading="lazy">' +
              (Sh.cardLine ? "<figcaption>" + esc(Sh.cardLine) + "</figcaption>" : "") + "</figure>"
            : "") +
        "</div>" +
        shotHTML(Sh.img, Sh.alt, Sh.callouts, "right");
      el.hidden = false;
      return;
    }
    swapText(el.querySelector("[data-os-shareline]"), pick(Sh.b, id));
  }

  /* ── 6. learn and doors ────────────────────────────────────── */
  function paintLearn() {
    var el = root.querySelector("[data-os-learn]");
    if (!el || !S.learn) return;
    el.innerHTML = S.learn.map(function (l) {
      var ic = l.icon ? icon(l.icon) : "";
      return '<a class="os-rm__card" href="' + esc(l.url) + '">' +
        (ic ? '<span class="os-rm__cardart"><img src="' + esc(ic) + '" alt="" loading="lazy"></span>' : "") +
        '<span class="os-rm__cardbody"><strong>' + esc(l.label) + "</strong><span>" + esc(l.note) + "</span></span>" +
      "</a>";
    }).join("");
  }
  function paintNext() {
    var el = root.querySelector("[data-os-next]");
    if (!el || !S.next) return;
    el.innerHTML = S.next.map(function (n) {
      var u = img(n.img);
      return '<a class="os-tile os-door" href="' + esc(roomUrl(n.slug)) + '" data-os-page="' + esc(n.slug) + '">' +
        (u ? '<img src="' + esc(u) + '" alt="" loading="lazy">' : "") +
        '<span class="os-tile__bar"><strong>' + esc(n.label) + "</strong></span></a>";
    }).join("");
  }

  /* ── geometry ──────────────────────────────────────────────
     Two kinds of line. Callout wires: from each label to its point
     on the screen. Flow links: from each device to its Tool, and
     from each Tool to the bean. All measured from live rects and
     redrawn whenever anything could have moved. */
  /* Positions are measured relative to the box that holds the SVG.
     Both the child and the box move together under the reveal
     transform on their shared ancestor, so the difference of their
     rects is exact even mid-transition. (offsetLeft/offsetTop was
     tried instead and Firefox reported the screen's image at twice
     its width, which put every line short.) */
  function rel(el, box) {
    var r = el.getBoundingClientRect(), b = box.getBoundingClientRect();
    return { l: r.left - b.left, t: r.top - b.top, w: r.width, h: r.height, r: r.right - b.left, b: r.bottom - b.top };
  }
  function setSvg(svg, box) {
    var b = box.getBoundingClientRect();
    var w = Math.max(1, b.width), h = Math.max(1, b.height);
    svg.setAttribute("viewBox", "0 0 " + w + " " + h);
    svg.setAttribute("width", w); svg.setAttribute("height", h);
  }
  function curve(x1, y1, x2, y2, cls, vertical) {
    var d;
    if (vertical) {
      var dy = (y2 - y1) * 0.5;
      d = "M" + x1 + " " + y1 + " C" + x1 + " " + (y1 + dy) + ", " + x2 + " " + (y2 - dy) + ", " + x2 + " " + y2;
    } else {
      var dx = (x2 - x1) * 0.5;
      d = "M" + x1 + " " + y1 + " C" + (x1 + dx) + " " + y1 + ", " + (x2 - dx) + " " + y2 + ", " + x2 + " " + y2;
    }
    /* A quiet base line, and a moving dashed line on top of it. */
    return '<path class="' + cls + '" d="' + d + '"/>' +
      (cls.indexOf("os-rm__link") === 0 ? '<path class="os-rm__link--dash" d="' + d + '"/>' : "");
  }
  /* One rule for every callout: the label sits level with the thing
     it names, and the line runs straight across to a dot beside it.
     The dot sits in the screen's margin, not on the text, unless a
     callout names a point (a dot on a chart), where it sits on the
     point. When two labels would collide the lower one is pushed
     down and its line bends gently to its row. */
  function drawShot(fig) {
    var svg = fig.querySelector(".os-rm__wires");
    var phone = fig.querySelector(".os-rm__phone img");
    var list = fig.querySelector(".os-rm__calls");
    var calls = fig.querySelectorAll(".os-rm__call");
    if (!svg || !phone || !list) return;
    var stacked = fig.classList.contains("is-stacked");
    if (stacked) {
      list.style.height = "";
      for (var k = 0; k < calls.length; k++) calls[k].style.top = "";
      svg.innerHTML = "";
      return;
    }
    var P = rel(phone, fig);
    var Lst = rel(list, fig);
    var left = (Lst.l + Lst.w / 2) < (P.l + P.w / 2);
    /* The label column is as tall as the screen so labels can sit
       level with their rows. */
    list.style.height = Math.round(P.h) + "px";
    var items = [];
    for (var i = 0; i < calls.length; i++) {
      var c = calls[i];
      var yPct = +c.getAttribute("data-y");
      var isPoint = c.getAttribute("data-point") === "1";
      var xPct = isPoint ? +c.getAttribute("data-x") : (left ? 3.5 : 96.5);
      items.push({ el: c, h: c.offsetHeight, py: P.t + P.h * yPct / 100, px: P.l + P.w * xPct / 100, point: isPoint });
    }
    items.sort(function (a, b) { return a.py - b.py; });
    /* Centre each label on its row, then push collisions down. */
    var gap = 8, cursor = P.t;
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      var top = it.py - it.h / 2;
      if (top < cursor) top = cursor;
      it.top = top; cursor = top + it.h + gap;
    }
    /* If the stack ran past the screen's bottom, lift everything. */
    var over = cursor - gap - (P.t + P.h);
    if (over > 0) for (var m = 0; m < items.length; m++) items[m].top -= over;
    setSvg(svg, fig);
    var out = "";
    for (var n = 0; n < items.length; n++) {
      var q = items[n];
      q.el.style.top = Math.round(q.top - Lst.t) + "px";
      var L = rel(q.el, fig);
      var lx = left ? L.r : L.l, ly = L.t + L.h / 2;
      var d;
      if (Math.abs(ly - q.py) < 1.5) {
        d = "M" + lx + " " + ly + " L" + q.px + " " + q.py;
      } else {
        /* straight out of the label, then a soft bend down or up to the row */
        var run = left ? 18 : -18;
        var mx = lx + run;
        var ex = q.px, ey = q.py;
        var cx = (mx + ex) / 2;
        d = "M" + lx + " " + ly + " L" + mx + " " + ly + " C" + cx + " " + ly + ", " + cx + " " + ey + ", " + ex + " " + ey;
      }
      out += '<path class="os-rm__wire" d="' + d + '"/>' +
        '<circle class="os-rm__dot" cx="' + q.px + '" cy="' + q.py + '" r="3.5"/>';
    }
    svg.innerHTML = out;
  }
  function drawGraph() {
    var g = root.querySelector("[data-os-graph]");
    if (!g) return;
    var svg = g.querySelector(".os-rm__links");
    var phone = g.querySelector(".os-rm__phone");
    if (!svg) return;
    setSvg(svg, g);
    var stacked = g.classList.contains("is-stacked");
    var narrow = g.classList.contains("is-narrow");
    var out = "";
    var tools = g.querySelectorAll("[data-flow-tool]");
    var n = tools.length;
    var P = phone ? rel(phone, g) : null;
    /* Right to left (Arabic): the columns run the other way, so each
       line leaves the device's left edge and meets the Tool's right. */
    var rtl = getComputedStyle(g).direction === "rtl";
    for (var i = 0; i < n; i++) {
      var t = tools[i], T = rel(t, g);
      var devs = g.querySelectorAll('[data-flow-dev][data-flow-group="' + i + '"]');
      for (var j = 0; j < devs.length; j++) {
        var R = rel(devs[j], g);
        if (narrow) {
          /* devices above their Tool: only the one touching it links down */
          if (j === devs.length - 1) out += rtl
            ? curve(R.r - 38, R.b, T.r - 36, T.t, "os-rm__link", true)
            : curve(R.l + 38, R.b, T.l + 36, T.t, "os-rm__link", true);
        } else {
          /* several devices converge on the Tool's middle; one meets its row */
          out += rtl
            ? curve(R.l, R.t + R.h / 2, T.r, T.t + T.h / 2, "os-rm__link")
            : curve(R.r, R.t + R.h / 2, T.l, T.t + T.h / 2, "os-rm__link");
        }
      }
      if (!stacked && P) {
        var py = P.t + P.h * (0.25 + 0.5 * (i + 0.5) / n);
        out += rtl
          ? curve(T.l, T.t + T.h / 2, P.r, py, "os-rm__link os-rm__link--bean")
          : curve(T.r, T.t + T.h / 2, P.l, py, "os-rm__link os-rm__link--bean");
      }
    }
    if (stacked && P && n) {
      /* Every Tool column feeds one line down into the bean below. */
      var last = tools[n - 1];
      if (last) {
        var LT = rel(last, g);
        out += curve(LT.l + LT.w / 2, LT.b, P.l + P.w / 2, P.t, "os-rm__link os-rm__link--bean", true);
      }
    }
    svg.innerHTML = out;
    var paths = svg.querySelectorAll(".os-rm__link--dash");
    for (var k = 0; k < paths.length; k++) paths[k].style.animationDelay = (-(k * 0.7)) + "s";
  }
  /* Layout is decided by the width the section actually has, not
     the viewport: the rail takes 265 px on a desktop, so a 948 px
     window gives this column about 650. */
  function layout() {
    var w = root.offsetWidth;
    root.classList.toggle("is-w1", w >= 600);
    root.classList.toggle("is-w2", w >= 880);
    root.classList.toggle("is-w3", w >= 1100);
    var g = root.querySelector("[data-os-graph]");
    if (g) { g.classList.toggle("is-stacked", w < 880); g.classList.toggle("is-narrow", w < 560); }
    var shots = root.querySelectorAll("[data-os-shot]");
    for (var i = 0; i < shots.length; i++) {
      shots[i].classList.toggle("is-stacked", w < 560);
      drawShot(shots[i]);
    }
    drawGraph();
  }
  var raf = 0;
  function relayout() { cancelAnimationFrame(raf); raf = requestAnimationFrame(layout); }
  /* Anything that can change a size redraws the lines: a size change
     on the section or on any figure, a transition ending, a font
     arriving, an image arriving. */
  function observeAll() {
    if (!("ResizeObserver" in window)) return;
    var ro = new ResizeObserver(relayout);
    ro.observe(root);
    var figs = root.querySelectorAll("[data-os-shot], .os-rm__phone img, .os-rm__call, [data-os-graph]");
    for (var fi = 0; fi < figs.length; fi++) ro.observe(figs[fi]);
  }
  root.addEventListener("transitionend", relayout);

  /* ── reveal ──────────────────────────────────────────────────
     Blocks rise in as they arrive. One class, one transition, and
     nothing waits for a threshold to start. */
  function watch() {
    var items = root.querySelectorAll(".os-rm__system, .os-rm__chain, .os-rm__flow, .os-rm__device, .os-rm__share, .os-rm__card");
    if (REDUCED || !("IntersectionObserver" in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add("is-seen");
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-seen"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  /* ── go ────────────────────────────────────────────────────── */
  var id = role();
  paintHead(id);
  paintSystem(id, true);
  paintChain(id, true);
  paintFlow(id, true);
  paintTools(id, true);
  paintShare(id, true);
  paintLearn();
  paintNext();
  layout();
  watch();
  observeAll();

  var imgs = root.querySelectorAll("img");
  for (var i = 0; i < imgs.length; i++) imgs[i].addEventListener("load", relayout);
  window.addEventListener("resize", relayout);
  if (D.fonts && D.fonts.ready) D.fonts.ready.then(relayout);
  setTimeout(relayout, 600);

  D.addEventListener("os:role", function (e) {
    var r = (e.detail && e.detail.role) || role();
    paintHead(r);
    paintSystem(r, false);
    paintChain(r, false);
    paintFlow(r, false);
    paintTools(r, false);
    paintShare(r, false);
    setTimeout(function () { relayout(); watch(); }, 350);
    setTimeout(relayout, 900);
  });
})();
